import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";

export default function ProtectedAdminRoute({ children, allowedRoles }) {
  const { user, checking } = useAuth();
  if (checking) return (
    <div className="min-h-screen grid place-items-center text-sm text-muted-foreground">Memuat...</div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (allowedRoles && !allowedRoles.includes(user.role)) return <Navigate to="/admin" replace />;
  return children;
}
